/** Shared parent-packet navigation helpers (Option C: forward always submits). */

export function isPacketFormComplete(form) {
  return form?.is_complete === true;
}

export function firstIncompleteFormIndex(forms) {
  if (!forms?.length) return 0;
  const idx = forms.findIndex((f) => !isPacketFormComplete(f));
  return idx >= 0 ? idx : forms.length;
}

/** Incomplete forms still required before the packet is done (for remaining-work cue). */
export function remainingIncompleteForms(forms) {
  if (!forms?.length) return [];
  return forms.filter((f) => !isPacketFormComplete(f));
}

export function forwardAdvanceIndexAfterComplete(currentIndex, formsLength) {
  if (!formsLength) return 0;
  return Math.min(currentIndex + 1, formsLength - 1);
}

export function isFormForwardComplete(form, { allowResubmit = false } = {}) {
  if (allowResubmit) return false;
  return isPacketFormComplete(form) || form?.status === 'signed';
}

export function forwardButtonLabel({
  form, hasParentFields, submitting, allowResubmit = false,
}) {
  if (submitting) return 'Submitting…';
  if (isFormForwardComplete(form, { allowResubmit })) return 'Continue';
  if (allowResubmit && hasParentFields) return 'Save changes & continue';
  return hasParentFields ? 'Submit & continue' : 'Mark as reviewed & continue';
}

export function isForwardDisabled({
  submitting, currentIndex, formsLength, form, allowResubmit = false, allFormsComplete = false,
}) {
  if (submitting) return true;
  if (allFormsComplete && currentIndex >= formsLength - 1) return false;
  return isFormForwardComplete(form, { allowResubmit }) && currentIndex >= formsLength - 1;
}
